module.exports = __webpack_public_path__ + "static/media/betcity.677fdb0a.png";